<template>
  <div class="content-info" v-show="contentInfoShow">
    <div class="info-title">
      <span class="info-title--prefix"></span>
      <span class="info-title--content">详情</span>
      <img src="@/assets/myImg/1/icon-close.png" class="info-title--sufix" @click="closeOverLay()" />
    </div>
    <a-spin :spinning="loading" tip="加载中..." class="info-content-wrapper">
      <div class="info-content">
        <div id="info-popup-content-page">
          <div class="info-content-item" v-for="item in infoData" :key="item.id">
            <span class="info-content-item-name">
              <span v-if="item.type === 'round'" class="round-dot">●</span>{{ item.name }}:
            </span>
            <span v-if="item.hyperlinkUrl" class="info-content-item-value-hyperlink" @click="handleHyperlink(item)">
              {{ item.value }}
            </span>
            <span v-else-if="item.clickable" class="info-content-item-value-clickable"
              @click="handleClickableField(item)">
              {{ item.value }}
            </span>
            <span v-else-if="item.components" class="info-content-item-value-hyperlink"
              @click="handleComponentsField(item)">
              {{ item.value }}
            </span>
            <span v-else-if="item.type === 'null'" class="info-content-item-value-list">

            </span>
            <span v-else class="info-content-item-value">
              {{ item.value }}
            </span>
          </div>
        </div>
        <div class="water-control-btn-wrapper" style="border-top: 1px solid rgba(255, 255, 255, 0.1);">
          <a-button type="primary" block @click="printpage">
            打印详情
          </a-button>
        </div>
        <!-- 片区范围示意图的上一级/下一级按钮 -->
        <div v-if="isZoneMetering" class="zone-level-btn-wrapper">
          <a-button type="primary" @click="handlePreviousLevel" :disabled="!hasPreviousLevel">
            上一级
          </a-button>
          <a-button type="primary" @click="handleNextLevel" :disabled="!hasNextLevel">
            下一级
          </a-button>
        </div>
      </div>
    </a-spin>
    <water-number-modal ref="WaterNumberModal" style="z-index: 9999;"></water-number-modal>
    <zone-user-modal ref="ZoneUserModalRef" style="z-index: 9999;"></zone-user-modal>
  </div>
</template>
<script>
import { getFeatureConfig, valveTypes } from '../mapModule/featureConfig.js'
import WaterNumberModal from '../WaterNumberModal'
import ZoneUserModal from '../ZoneUserModal'
import { Spin } from 'ant-design-vue'
import printJs from 'print-js'
import { geoserverWFS } from '@/api/manage'

// 日期格式化函数
function GetDateStr (AddDayCount) {
  var dd = new Date()
  dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
  var y = dd.getFullYear()
  var m = dd.getMonth() + 1 // 获取当前月份的日期
  var d = dd.getDate()
  if (m < 10) m = '0' + m
  if (d < 10) d = '0' + d
  return y + '-' + m + '-' + d + ' 00:00:00'
}
export default {
  components: {
    WaterNumberModal,
    ZoneUserModal,
    'a-spin': Spin
  },
  name: 'InfoMap',
  props: {
    layerLeval: {
      type: [Number, String],
      default: 1
    }
  },
  watch: {
    layerLeval: {
      handler (newVal, oldVal) {
        console.log('图层等级变化:', oldVal, '->', newVal);
        // 可以在这里处理图层等级变化时的逻辑
        // 例如：重新加载数据、更新显示等
      },
      immediate: true
    }
  },
  data () {
    return {
      contentInfoShow: false,
      infoData: [],
      loading: false, // 加载状态
      isZoneMetering: false, // 是否是片区范围示意图
      currentFeature: null, // 当前选中的要素
      currentFeatureData: null, // 当前要素的原始数据，用于获取 class_no 等字段
      zoneMeteringData: {
        zoneName: '', //片区名称
        nd75Above: '', //DN75以上管网长度
        userCount: '', //用户数
        nightFlow: '', //夜间流量
        waterSupplycapacity: '', //昨日供水量
        yesterdaySales: '', //昨日售水量
        iflowRate: '', //瞬时流量
        zoneId: '', //片区ID
      },
      queryParams: {
        queryBeginTime: GetDateStr(0),
        queryEndTime: GetDateStr(1),
        queryField: '',
        zoneId: '', //片区ID
        isMoment: false,
        isType: false,
      },
    }
  },
  computed: {
    // 是否可以上一级（有有效的 pid_str）
    hasPreviousLevel () {
      if (!this.currentFeature || !this.currentFeature.properties) {
        return false;
      }
      const pidStr = this.currentFeature.properties.pid_str;
      // 检查 pid_str 是否存在且不是 0、null、空字符串等无效值
      return pidStr !== null && pidStr !== undefined && pidStr !== '' && pidStr !== '0' && pidStr !== 0;
    },
    // 是否可以下一级（有有效的 zone_id）
    hasNextLevel () {
      if (!this.currentFeature || !this.currentFeature.properties) {
        return false;
      }
      const zoneId = this.currentFeature.properties.zone_id;
      // 检查 zone_id 是否存在且不是 0、null、空字符串等无效值
      return zoneId !== null && zoneId !== undefined && zoneId !== '' && zoneId !== '0' && zoneId !== 0;
    }
  },
  methods: {
    handleFeatureData (feature) {
      console.log('要素数据:', feature)
      this.loadFeatureData(feature)
    },
    loadFeatureData (feature) {
      // 每次加载新要素时，先隐藏子分区详情框
      this.$emit('hide-child-zone-box');
      console.log('要素ID:', feature.id);
      this.contentInfoShow = true;
      this.currentFeature = feature; // 保存当前要素

      // 检查是否是片区范围示意图
      if (this.isZoneMeteringFeature(feature)) {
        this.isZoneMetering = true;
        // 片区范围示意图需要先请求接口
        this.loadZoneMeteringData(feature);
        return;
      }

      // 如果不是片区范围示意图，先重置数据
      this.isZoneMetering = false;
      this.resetZoneMeteringData();

      // 使用封装的ID判断方法
      const id = this.parseFeatureId(feature);
      console.log('要素ID:', id);
      // 根据要素ID获取配置
      const config = getFeatureConfig(id);
      if (config) {
        console.log('找到要素配置:', config);
        this.handleFeature(feature.properties, config);
      } else {
        console.log('未找到对应的要素配置');
        this.infoData = [];
      }
    },

    // 判断是否是片区范围示意图要素
    isZoneMeteringFeature (feature) {
      const { id, properties } = feature;
      // 根据要素ID或属性判断是否是片区范围示意图
      if (id && id.includes('zone_metering')) {
        return true;
      }
      if (properties && (properties.layerName === '片区范围示意图' || properties.layer_code === 'zone_park_water')) {
        return true;
      }
      return false;
    },

    // 加载片区范围示意图数据
    async loadZoneMeteringData (feature) {
      let that = this;
      // 获取片区ID（从 properties 中获取）
      let zoneId = feature.properties?.id || feature.properties?.zoneId || feature.id;

      // 如果ID包含 zone_metering. 前缀，则截取后面的部分
      if (zoneId && typeof zoneId === 'string' && zoneId.includes('zone_metering.')) {
        zoneId = zoneId.replace('zone_metering.', '');
      }

      if (!zoneId) {
        console.warn('片区范围示意图缺少ID，无法请求数据');
        this.infoData = [];
        return;
      }

      console.log('请求片区数据，ID:', zoneId);
      console.log(that.zoneMeteringData);
      this.queryParams.zoneId = zoneId;

      // 开始加载
      this.loading = true;

      try {
        this.zoneMeteringData.zoneName = feature.properties.zone_name;
        this.zoneMeteringData.zoneId = zoneId;

        // 请求长度接口
        try {
          const res1 = await this.$http.get(`/zone-metering/data-analyse/water-supply/${zoneId}`);
          this.zoneMeteringData.dn75Above = res1.data?.pipelineLength || '';
        } catch (error) {
          console.error('请求长度接口失败:', error);
        }


        // 请求夜间流量接口
        try {
          this.queryParams.queryField = 'night_flow';
          const res3 = await this.$http.get(`/pipe-network/report/chart/night-traffic/count`, { params: this.queryParams });
          // 获取 dataList[0] 中所有对象的 value 总和（dataList[0] 是二维数组）
          const dataList = res3.data?.dataList?.[0] || [];
          // 扁平化二维数组，然后提取 value 并转换为数字，最后求和
          const nightFlowSum = dataList.flat().map(item => parseFloat(item?.value) || 0).reduce((a, b) => a + b, 0);
          this.zoneMeteringData.nightFlow = nightFlowSum === 0 ? '' : nightFlowSum.toFixed(2);
        } catch (error) {
          console.error('请求夜间流量接口失败:', error);
        }

        // 请求瞬时流量接口
        try {
          this.queryParams.queryField = 'flow_rate';
          this.queryParams.stepLength = 5;
          this.queryParams.isMoment = true;
          this.queryParams.isType = true;
          const res4 = await this.$http.get(`/pipe-network/report/chart/night-traffic`, { params: this.queryParams });
          this.zoneMeteringData.iflowRate = res4.data?.data?.[0]?.[res4.data.data[0].length - 1]?.value || '';
        } catch (error) {
          console.error('请求瞬时流量接口失败:', error);
        }

        // 请求用户数接口
        try {
          const res5 = await this.$http.get(`/pipe-network/zone-metering/get/zone/waterMeter/user/count/${zoneId}`);
          this.zoneMeteringData.userCount = res5.data || '';
        } catch (error) {
          console.error('请求用户数接口失败:', error);
        }

        // 请求昨日售水量&昨日产销差率
        try {
          const res6 = await this.$http.get(`/zone-metering/data-analyse/yesterday-sales/${zoneId}`);
          let data = res6.data[0]
          this.zoneMeteringData.waterForSale = Number(data.sellWater).toFixed(2) || '';
          this.zoneMeteringData.productionAndSalesMargin = data.productionMarketing || '';
          this.zoneMeteringData.waterSupplycapacity = Number(data.supplyWater).toFixed(2) || '';
        } catch (error) {
          console.error('请求昨日售水量接口失败:', error);
          this.zoneMeteringData.waterForSale = '';
          this.zoneMeteringData.productionAndSalesMargin = '';
          this.zoneMeteringData.waterSupplycapacity = '';
        }

        // 请求子分区接口
        try {
          const res8 = await this.$http.get(`/zone-metering/data-analyse/sub-zones-count/${zoneId}`);
          this.zoneMeteringData.subpartitioning = res8.message || '';
        } catch (error) {
          console.error('请求子分区接口失败:', error);
        }

        // 请求累计报警接口
        try {
          const res9 = await this.$http.get(`/zone-metering/data-analyse/alarm-summary/${zoneId}`);
          if (res9.data && res9.data.length > 0) {
            res9.data.forEach(item => {
              if (item.alarmType === '预警') {
                this.zoneMeteringData.earlyWarning = item.count
              } else if (item.alarmType === '报警') {
                this.zoneMeteringData.alarm = item.count
              } else if (item.alarmType === '数据中断') {
                this.zoneMeteringData.interrupt = item.count
              }
            })
          }
        } catch (error) {
          console.error('请求累计报警接口失败:', error);
        }


        console.log('所有接口请求完成，片区数据:', this.zoneMeteringData);

        // 通知父组件更新片区选择器的显示值
        if (this.zoneMeteringData.zoneId && this.zoneMeteringData.zoneName) {
          this.$emit('update-zone-selector', {
            key: this.zoneMeteringData.zoneId,
            label: this.zoneMeteringData.zoneName
          });
          console.log('已触发更新片区选择器事件:', {
            key: this.zoneMeteringData.zoneId,
            label: this.zoneMeteringData.zoneName
          });
        }

        // 所有接口请求完成后，使用 zoneMeteringData 作为片区范围示意图的数据对象
        // 获取片区范围示意图的配置
        const config = getFeatureConfig('zone_metering');
        if (config) {
          console.log('找到片区范围示意图配置:', config);
          // 使用 handleFeature 方法处理数据并显示
          this.handleFeature(this.zoneMeteringData, config);
        } else {
          console.log('未找到片区范围示意图的配置');
          // 如果没有配置，可以显示原始数据
          this.infoData = Object.keys(this.zoneMeteringData).map(key => ({
            id: key,
            name: key,
            value: this.zoneMeteringData[key] || '暂无数据'
          }));
        }
      } finally {
        // 结束加载
        this.loading = false;
      }
    },

    // 解析要素ID，返回标准化的要素类型
    parseFeatureId (feature) {
      const { id, properties } = feature

      if (id.includes('gis_pipe_line')) {
        return 'gis_pipe_line'
      }

      if (id.includes('gis_pipe_network')) {
        const { appendage, structure } = properties || {}

        if (appendage && valveTypes[appendage]) {
          return valveTypes[appendage]
        }

        if (appendage) {
          return 'gis_pipe_network_appendage'
        }

        if (structure) {
          return 'gis_pipe_network_structure'
        }

        return 'gis_pipe_network'
      }

      //分界阀门
      if (id.includes('zone_associated_point')) {
        return 'zone_associated_point'
      }

      //分区计量仪表
      if (id.includes('remote_water_meter')) {
        return 'remote_water_meter'
      }

      return id
    },


    // 处理要素
    handleFeature (data, elements) {
      console.log('处理要素数据:', data);

      // 保存当前要素的原始数据，用于后续获取 class_no 等字段
      this.currentFeatureData = data;

      this.infoData = elements.map(item => {
        const rawValue = data[item.id] || '暂无数据';
        let displayValue = rawValue;
        let hyperlinkUrl = '';

        // 应用格式化规则
        if (item.rule && rawValue !== '暂无数据') {
          displayValue = this.formatValue(rawValue, item.rule);
        }

        // 构建超链接URL
        if (item.hyperlink) {
          hyperlinkUrl = this.buildHyperlinkUrl(item.hyperlink, data);
        }
        console.log(hyperlinkUrl);

        // 处理可点击字段的value设置
        let clickableConfig = item.clickable;
        if (clickableConfig && typeof clickableConfig === 'object' && clickableConfig.type) {
          clickableConfig = {
            ...clickableConfig,
            value: data[clickableConfig.type] || ''
          };
        }

        return {
          ...item,
          value: displayValue,
          hyperlinkUrl: hyperlinkUrl,
          clickable: clickableConfig
        };
      });

      console.log('处理后的信息数据:', this.infoData);
    },

    // 格式化值
    formatValue (value, rule) {
      if (rule.position === 'before') {
        return rule.text + value;
      } else if (rule.position === 'after') {
        return value + rule.text;
      }
      return value;
    },

    // 构建超链接URL
    buildHyperlinkUrl (hyperlink, data) {
      let url = hyperlink.url;
      hyperlink.value.forEach(fieldName => {
        const fieldValue = data[fieldName] || '';
        // 替换最后一个 = 后面的内容
        const lastEqualIndex = url.lastIndexOf('=');
        if (lastEqualIndex !== -1) {
          url = url.substring(0, lastEqualIndex + 1) + fieldValue;
        }
      });
      return url;
    },

    handleHyperlink (item) {
      console.log('点击了超链接:', item);

      // 如果是 appearance_no，需要先异步获取 zoneId
      if (item.hyperlink && item.hyperlink.id === 'appearance_no') {
        // 从保存的原始数据中获取 class_no 和 appearance_no
        const classNo = this.currentFeatureData?.class_no;
        const appearanceNo = item.value || this.currentFeatureData?.appearance_no;

        if (!classNo) {
          console.warn('缺少 class_no，无法获取 zoneId');
          this.$message.warning('缺少必要参数，无法打开链接');
          return;
        }

        // 发起请求获取 zoneId
        this.$http
          .get(`/pipe-network/zone-metering/get/waterMeter/zoneId/${classNo}/${this.layerLeval}`)
          .then((res) => {
            console.log('获取 zoneId 响应:', res);

            const zoneId = res.data ? Object.values(res.data)[0] : '';
            if (!zoneId) {
              console.warn('未获取到 zoneId');
              this.$message.warning('未获取到片区信息');
              return;
            }

            // 构建完整的 URL
            const url = this.$router.resolve({
              path: item.hyperlinkUrl,
              query: {
                type: 'flow_rate',
                zoneId: zoneId,
                waterMeterId: appearanceNo,
              },
            });

            // 打开链接
            if (item.hyperlink.way === 'open') {
              window.open(url.href, '_blank')
            }
          })
          .catch((error) => {
            console.error('获取 zoneId 失败:', error);
            this.$message.error('获取片区信息失败');
          });
      } else {
        // 其他情况直接打开链接
        if (item.hyperlink.way === 'open') {
          window.open(item.hyperlinkUrl);
        }
      }
    },

    // 处理可点击字段
    handleClickableField (item) {
      console.log('点击了可点击字段:', item);

      // 根据字段类型执行不同的操作
      switch (item.id) {
        case 'userCount':
          this.showZoneUser(item);
          break;

      }
    },
    handleComponentsField (item) {
      console.log('点击了组件字段:', item);
      // 从 zoneMeteringData 中获取实际的 zoneId 值
      const fieldName = item.components.value;
      const zoneId = this.zoneMeteringData[fieldName] || '';
      // 通过事件通知父组件切换子分区框显示状态
      this.$emit('show-child-zone-box', {
        zoneId: zoneId,
        zoneName: this.zoneMeteringData.zoneName,
        toggle: true // 传递 toggle 标志，让父组件切换状态
      });
    },

    // 查看分区用户数
    showZoneUser (item) {
      this.$nextTick(() => {
        this.$refs.ZoneUserModalRef.getDataList(this.zoneMeteringData.zoneName, this.zoneMeteringData.zoneId)
      })
    },


    // 重置片区范围示意图数据
    resetZoneMeteringData () {
      this.zoneMeteringData = {
        zoneName: '', //片区名称
        nd75Above: '', //DN75以上管网长度
        userCount: '', //用户数
        nightFlow: '', //夜间流量
        waterSupplycapacity: '', //昨日供水量
        yesterdaySales: '', //昨日售水量
        iflowRate: '', //瞬时流量
        zoneId: '', //片区ID
      };
      this.queryParams = {
        queryBeginTime: GetDateStr(0),
        queryEndTime: GetDateStr(1),
        queryField: '',
        zoneId: '', //片区ID
        isMoment: false,
        isType: false,
      };
    },

    closeOverLay () {
      // 关闭详情框时，同时隐藏子分区详情框
      this.$emit('hide-child-zone-box');
      this.contentInfoShow = false
      this.isZoneMetering = false
      this.currentFeature = null
      // 告知父组件清除矢量图层
      this.$emit('close-overlay')
    },
    // 处理上一级按钮点击
    handlePreviousLevel () {
      if (!this.currentFeature || !this.currentFeature.properties) {
        console.warn('无法获取上一级：缺少要素信息');
        return;
      }

      const pidStr = this.currentFeature.properties.pid_str;
      if (!pidStr) {
        console.warn('无法获取上一级：缺少 pid_str');
        return;
      }

      // 通过事件通知父组件更新WMS图层查询条件
      // 上一级使用 zone_id 条件
      this.$emit('update-zone-layer-filter', { zoneId: pidStr, usePidStr: false });

      const tenantId = this.$store?.state?.user?.info?.tenantId || '';
      const cql = `is_deleted = false and zone_id = '${pidStr}' and tenant_id = '${tenantId}'`;

      console.log('查询上一级片区，CQL:', cql);

      // 关闭详情框
      this.contentInfoShow = false;
      this.isZoneMetering = false;
      this.currentFeature = null;
      // 告知父组件清除矢量图层
      this.$emit('close-overlay');

      // 通过 geoserverWFS 获取片区数据
      geoserverWFS('smart_water', 'zone_metering', '&CQL_FILTER=' + cql).then((res) => {
        if (res.data && res.data.features && res.data.features.length > 0) {
          const feature = res.data.features[0];
          console.log('找到上一级片区:', feature);
          // 不触发 feature-selected 事件，因为已经关闭了详情框
        } else {
          console.warn('未找到上一级片区数据');
          this.$message.warning('未找到上一级片区');
        }
      }).catch((error) => {
        console.error('获取上一级片区数据失败:', error);
        this.$message.error('获取上一级片区数据失败');
      });
    },
    // 处理下一级按钮点击
    handleNextLevel () {
      if (!this.currentFeature || !this.currentFeature.properties) {
        console.warn('无法获取下一级：缺少要素信息');
        return;
      }

      const zoneId = this.currentFeature.properties.zone_id;
      if (!zoneId) {
        console.warn('无法获取下一级：缺少 zone_id');
        return;
      }

      const tenantId = this.$store?.state?.user?.info?.tenantId || '';
      const cql = `is_deleted = false and pid_str = '${zoneId}' and tenant_id = '${tenantId}'`;

      console.log('查询下一级片区，CQL:', cql);

      // 关闭详情框
      this.contentInfoShow = false;
      this.isZoneMetering = false;
      this.currentFeature = null;
      // 告知父组件清除矢量图层
      this.$emit('close-overlay');

      // 通过 geoserverWFS 获取片区数据
      geoserverWFS('smart_water', 'zone_metering', '&CQL_FILTER=' + cql).then((res) => {
        if (res.data && res.data.features && res.data.features.length > 0) {
          // 如果有多个下一级，取第一个
          const feature = res.data.features[0];
          const nextZoneId = feature.properties?.zone_id || feature.properties?.id;

          console.log('找到下一级片区:', feature, 'zoneId:', nextZoneId);

          // 通过事件通知父组件更新WMS图层查询条件
          // 下一级使用 pid_str 条件
          if (zoneId) {
            this.$emit('update-zone-layer-filter', { zoneId: zoneId, usePidStr: true });
          }

          // 不触发 feature-selected 事件，因为已经关闭了详情框
        } else {
          console.warn('未找到下一级片区数据');
          this.$message.warning('未找到下一级片区');
        }
      }).catch((error) => {
        console.error('获取下一级片区数据失败:', error);
        this.$message.error('获取下一级片区数据失败');
      });
    },
    printpage () {
      const style = `
        @page { margin: 10mm; }
        .info-content-item {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          line-height: 30px !important;
          page-break-inside: avoid !important;
          width: 100% !important;
        }
        .info-content-item-name {
          font-size: 14px !important;
          color: #000 !important;
          flex-shrink: 0 !important;
          margin-right: 10px !important;
        }
        .info-content-item-value,
        .info-content-item-value-hyperlink,
        .info-content-item-value-clickable {
          font-size: 14px !important;
          color: #000 !important;
          text-align: right !important;
          word-break: break-all !important;
        }
      `
      printJs({
        printable: 'info-popup-content-page',
        type: 'html',
        scanStyles: false,
        style: style,
        header: '<h3 style="text-align: center; margin: 10px 0;">详情信息</h3>'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content-info {
  position: absolute;
  background: rgba(0, 32, 54, 0.75);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  top: 3%;
  right: 24px;
  z-index: 5;
  width: 240px;

  .info-title {
    background-image: linear-gradient(270deg, rgba(7, 142, 231, 0.959) 0%, #0890f2 100%);
    border-radius: 6px 6px 0 0;
    display: flex;
    height: 46px;
    align-items: center;
    color: #ffffff;
    // margin-bottom: 9px;

    .info-title--prefix {
      width: 4px;
      height: 12px;
      background-color: #0890f2;
      margin-right: 5px;
      margin-left: 12px;
    }

    .info-title--content {
      width: 100%;
      flex: 1;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 12px;
      color: #ffffff;
      font-weight: 600;
      line-height: 12px;
      height: 12px;
    }

    .info-title--sufix {
      width: 12px;
      height: 12px;
      margin-right: 12px;
    }
  }

  .info-content-wrapper {
    /deep/ .ant-spin {
      max-height: none;
    }

    /deep/ .ant-spin-container {
      min-height: 200px;
    }

    /deep/ .ant-spin-text {
      color: #ffffff;
    }
  }

  .info-content {
    padding: 12px;

    .info-content-item {
      line-height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .info-content-item-name {
      font-size: 14px;
      color: #ffffff;
      display: flex;
      align-items: center;

      .round-dot {
        display: inline-block;
        margin-right: 15px;
        font-size: 12px;
      }
    }

    .info-content-item-value {
      font-size: 14px;
      color: #ffffff;
    }

    .info-content-item-value-hyperlink {
      color: #0890f2;
      cursor: pointer;
    }

    .info-content-item-value-clickable {
      color: #52c41a;
      cursor: pointer;
      text-decoration: underline;
      transition: all 0.3s ease;

      &:hover {
        color: #389e0d;
        text-decoration: none;
      }
    }
  }

  .water-control-btn-wrapper {
    margin-top: 10px !important;
    padding-top: 12px;

    :deep(.ant-btn) {
      background: linear-gradient(135deg, #0890f2, #078ee7);
      border: none;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      height: 36px;
      box-shadow: 0 2px 8px rgba(8, 144, 242, 0.3);
      transition: all 0.3s ease;

      &:hover {
        background: linear-gradient(135deg, #078ee7, #0681d6);
        box-shadow: 0 4px 12px rgba(8, 144, 242, 0.5);
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  .zone-level-btn-wrapper {
    margin-top: 10px !important;
    padding-top: 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    gap: 5px;

    :deep(.ant-btn) {
      flex: 1;
      background: linear-gradient(135deg, #0890f2, #078ee7);
      border: none;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      height: 36px;
      box-shadow: 0 2px 8px rgba(8, 144, 242, 0.3);
      transition: all 0.3s ease;

      &:hover:not(:disabled) {
        background: linear-gradient(135deg, #078ee7, #0681d6);
        box-shadow: 0 4px 12px rgba(8, 144, 242, 0.5);
        transform: translateY(-2px);
      }

      &:active:not(:disabled) {
        transform: translateY(0);
      }

      &:disabled {
        background: #d9d9d9 !important;
        color: #ffffff !important;
        border: none !important;
        cursor: not-allowed;
        box-shadow: none !important;
        opacity: 1;
      }
    }
  }
}
</style>
